export const QUOTES = [
  'No great thing is created suddenly',
  'Who are you when no one is watching',
  'What worries you, masters you',
  'You are the victim of your own mind',
  'Everything we hear is an opinion, not a fact. Everything we see is a perspective, not the truth.'
];
